/**
 * Doorware Product Page JS
 * File: assets/dw-product.js
 *
 * Load in theme.liquid before </body>:
 *   {{ 'dw-product.js' | asset_url | script_tag }}
 * Or use defer:
 *   <script src="{{ 'dw-product.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  if (!document.querySelector('.dw-wrap')) return;

  function dwContractorPriceMultiplier() {
    const m = window.doorwareContractorPriceMultiplier;
    return (typeof m === 'number' && !isNaN(m) && m > 0 && m <= 1) ? m : 0.93;
  }

  function dwContractorDiscountActive() {
    if (window.doorwareContractorFlatDiscountEnabled === false) return false;
    if (window.doorwareContractorDiscountActive === true) return true;
    if (window.doorwareContractorDiscountActive === false) return false;
    return !!(
      (window.doorwareCustomer && window.doorwareCustomer.is_contractor) ||
      data.isContractor
    );
  }

  function dwIsContractorCustomer() {
    return dwContractorDiscountActive();
  }

  function dwContractorCents(retailCents) {
    return Math.round(retailCents * dwContractorPriceMultiplier());
  }

  function dwEnsureContractorDisplay(retailCents) {
    if (!dwIsContractorCustomer() || !retailCents) return;

    let block = document.querySelector('.dw-contractor-pricing-display');
    if (!block) {
      const priceRow = document.getElementById('dw-price-row');
      const anchor = priceRow ? priceRow.closest('.dw-price-box') || priceRow.parentElement : null;
      if (!anchor) return;
      block = document.createElement('div');
      block.className = 'dw-contractor-pricing-display';
      block.innerHTML =
        '<span class="dw-con-price-label">Contractor price:</span> ' +
        '<strong class="dw-con-price-val"></strong>';
      anchor.insertAdjacentElement('afterend', block);
    }

    const contractorCents = dwContractorCents(retailCents);
    const conVal = block.querySelector('.dw-con-price-val');
    const conRetail = block.querySelector('.dw-con-price-retail');
    if (conRetail) conRetail.remove();
    if (conVal) conVal.textContent = dwFormatMoney(contractorCents);
    block.hidden = false;
  }

  /* ────────────────────────────────────────
     VARIANT SELECTION ENGINE
     Handles finish swatches + function pills
     + door thickness → resolves Shopify variant
  ──────────────────────────────────────── */

  const data        = window.dwProductData || {};
  const variants    = data.variants || [];
  const presentmentPrices = data.presentmentPrices || {};
  variants.forEach(function (variant) {
    const presentment = presentmentPrices[String(variant.id)];
    if (typeof presentment === 'number') variant.price = presentment;
  });
  if (data.currentVariant) {
    const currentPresentment = presentmentPrices[String(data.currentVariant.id)];
    if (typeof currentPresentment === 'number') data.currentVariant.price = currentPresentment;
  }
  let   selected    = {};                        // { option1: '...', option2: '...', option3: '...' }

  // Seed from current variant
  if (data.currentVariant) {
    selected.option1 = data.currentVariant.option1;
    selected.option2 = data.currentVariant.option2;
    selected.option3 = data.currentVariant.option3;
  }

  function findVariant() {
    return variants.find(v =>
      (!selected.option1 || v.option1 === selected.option1) &&
      (!selected.option2 || v.option2 === selected.option2) &&
      (!selected.option3 || v.option3 === selected.option3)
    ) || null;
  }

  function dwNotifyStockHtml() {
    return '<span class="dw-stock-dot dw-stock-out"></span> Out of Stock — <a href="#notify" class="dw-notify-link">Notify me</a>';
  }

  function dwSyncAddButtonForAvailability(variant) {
    const cartBtn = document.getElementById('dw-add-btn');
    const stickyBtn = document.getElementById('dw-sticky-add-btn');
    if (!variant || !cartBtn) return;

    if (variant.available) {
      cartBtn.type = 'submit';
      cartBtn.removeAttribute('data-dw-notify');
      cartBtn.classList.remove('dw-add-btn--notify');
      cartBtn.disabled = false;
      cartBtn.setAttribute('aria-label', 'Add to cart');
      if (cartBtn.textContent === 'Out of Stock') {
        cartBtn.textContent = 'Add to Cart';
      }
      if (stickyBtn) {
        stickyBtn.textContent = 'Add to Cart';
        stickyBtn.setAttribute('aria-label', 'Add to cart');
        stickyBtn.removeAttribute('data-dw-notify');
        stickyBtn.classList.remove('dw-btn-sb--notify');
      }
    } else {
      cartBtn.type = 'button';
      cartBtn.setAttribute('data-dw-notify', 'true');
      cartBtn.classList.add('dw-add-btn--notify');
      cartBtn.disabled = false;
      cartBtn.textContent = 'Out of Stock';
      cartBtn.setAttribute('aria-label', 'Notify me when back in stock');
      if (stickyBtn) {
        stickyBtn.textContent = 'Notify me';
        stickyBtn.setAttribute('aria-label', 'Notify me when back in stock');
        stickyBtn.setAttribute('data-dw-notify', 'true');
        stickyBtn.classList.add('dw-btn-sb--notify');
      }
    }
  }

  function dwSyncNotifyFormFields(variant) {
    if (!variant) return;
    const wrap = dwNotifyFormWrap();
    const productTitle = data.productTitle || document.querySelector('.dw-title')?.textContent?.trim() || '';
    const variantLabel = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    const origin = window.location.origin || '';
    const path = window.location.pathname || '';
    const productUrl = origin + path;

    if (wrap) {
      wrap.dataset.dwNotifyVariantId = String(variant.id);
      wrap.dataset.dwNotifyVariantTitle = variantLabel || variant.title || '';
      wrap.dataset.dwNotifySku = variant.sku || '';
      wrap.dataset.dwNotifyProductTitle = productTitle;
      wrap.dataset.dwNotifyProductUrl = productUrl;
      wrap.dataset.dwNotifyProductDisplay = productTitle + (variantLabel ? ' — ' + variantLabel : '');
      if (data.productId) wrap.dataset.dwNotifyProductId = String(data.productId);
    }

    const idEl = document.getElementById('dw-notify-variant-id');
    const skuEl = document.getElementById('dw-notify-sku');
    const titleEl = document.getElementById('dw-notify-variant-title');
    const productEl = document.getElementById('dw-notify-product-line');
    const productLine = productTitle + (variantLabel ? ' — ' + variantLabel : '') + ' — ' + productUrl;
    if (idEl) idEl.value = variant.id;
    if (skuEl) skuEl.value = variant.sku || '';
    if (titleEl) titleEl.value = variantLabel || variant.title || '';
    if (productEl) productEl.value = productLine;

    const productDisplay = wrap?.querySelector('[data-dw-notify-display="product"]');
    const productLabel = productTitle + (variantLabel ? ' — ' + variantLabel : '');
    if (productDisplay) {
      productDisplay.value = productLabel;
      if (wrap) wrap.dataset.dwNotifyProductDisplay = productLabel;
    }
  }

  function dwOpenNotifyModal() {
    const modal = document.getElementById('dw-notify-modal');
    if (!modal) return;
    const variant = findVariant() || data.currentVariant;
    dwSyncNotifyFormFields(variant);
    modal.hidden = false;
    modal.style.display = 'flex';
    document.body.classList.add('dw-notify-modal-open');
    const wrap = dwNotifyFormWrap();
    if (wrap) {
      dwNotifySetStatus(wrap, '', null);
      dwNotifyPrefill(wrap);
    }
    const focusTarget =
      modal.querySelector('.dw-notify-form input[type="email"]') ||
      modal.querySelector('[data-dw-notify-close]');
    if (focusTarget && focusTarget.focus) {
      try {
        focusTarget.focus({ preventScroll: true });
      } catch (err) {
        focusTarget.focus();
      }
    }
  }

  function dwCloseNotifyModal() {
    const modal = document.getElementById('dw-notify-modal');
    if (!modal) return;
    modal.hidden = true;
    modal.style.display = '';
    document.body.classList.remove('dw-notify-modal-open');
  }

  window.dwOpenNotifyModal = dwOpenNotifyModal;
  window.dwCloseNotifyModal = dwCloseNotifyModal;

  function dwNotifyFormWrap() {
    return document.getElementById('dw-notify-form-wrap');
  }

  function dwNotifyUsesShopifyForms() {
    const wrap = dwNotifyFormWrap();
    return !!(wrap && wrap.getAttribute('data-dw-notify-shopify-form-id'));
  }

  const DW_NOTIFY_SKIP_LABELS = [
    'first name', 'last name', 'full name', 'your name', 'name',
    'submitted by', 'submit by', 'submitted', 'phone', 'tel', 'mobile',
    'company', 'organization', 'address', 'city', 'state', 'province',
    'zip', 'postal', 'country', 'email address'
  ];

  function dwNotifyNormLabel(text) {
    return String(text || '').replace(/\*/g, '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function dwNotifyFieldLabel(field) {
    if (!field) return '';
    let label = field.getAttribute('aria-label') || '';
    const root = field.getRootNode && field.getRootNode();
    if (field.id && root && root.querySelector) {
      const lab = root.querySelector('label[for="' + String(field.id).replace(/"/g, '\\"') + '"]');
      if (lab) label = lab.textContent || label;
    }
    if (!label && field.closest) {
      const parentLabel = field.closest('label');
      if (parentLabel) label = parentLabel.textContent || label;
    }
    if (!label && field.parentElement && field.parentElement.querySelector) {
      const sib = field.parentElement.querySelector('label, legend');
      if (sib) label = sib.textContent || label;
    }
    if (!label) {
      const ph = field.getAttribute('placeholder') || '';
      if (ph) label = ph;
    }
    return dwNotifyNormLabel(label);
  }

  function dwNotifyLabelLists(wrap) {
    const ds = wrap ? wrap.dataset : {};
    function split(key, fallback) {
      return String(ds[key] || fallback).split(',').map(dwNotifyNormLabel).filter(Boolean);
    }
    return {
      product: split('dwNotifyLabelProduct', 'product,product title,product name'),
      sku: split('dwNotifyLabelSku', 'sku'),
      productId: split('dwNotifyLabelProductId', 'shopify product id,product id,shopify id'),
      notes: split('dwNotifyLabelNotes', 'notes,note')
    };
  }

  function dwNotifyLabelMatches(label, allowed) {
    const n = dwNotifyNormLabel(label);
    if (!n || DW_NOTIFY_SKIP_LABELS.indexOf(n) !== -1) return false;
    return allowed.indexOf(n) !== -1;
  }

  function dwNotifyDiscoverSlots(shadow, wrap) {
    const lists = dwNotifyLabelLists(wrap);
    const slots = { email: null, product: null, sku: null, productId: null, notes: null };
    if (!shadow) return slots;
    Array.from(shadow.querySelectorAll('input, textarea, select')).forEach(field => {
      const label = dwNotifyFieldLabel(field);
      if (!label || DW_NOTIFY_SKIP_LABELS.indexOf(label) !== -1) return;
      if (field.type === 'email' || label === 'email' || label === 'e-mail') {
        slots.email = field;
        return;
      }
      if (dwNotifyLabelMatches(label, lists.product)) slots.product = field;
      else if (dwNotifyLabelMatches(label, lists.sku)) slots.sku = field;
      else if (dwNotifyLabelMatches(label, lists.productId)) slots.productId = field;
      else if (dwNotifyLabelMatches(label, lists.notes)) slots.notes = field;
    });
    return slots;
  }

  function dwNotifyRefreshSlots(wrap) {
    if (!wrap || !wrap._dwNotifyShadow) return;
    wrap._dwNotifySlots = dwNotifyDiscoverSlots(wrap._dwNotifyShadow, wrap);
  }

  function dwNotifySetFieldValue(field, value) {
    if (!field) return;
    const str = String(value);
    const proto = field.tagName === 'TEXTAREA'
      ? window.HTMLTextAreaElement.prototype
      : window.HTMLInputElement.prototype;
    const desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) desc.set.call(field, str);
    else field.value = str;
    try {
      field.dispatchEvent(new InputEvent('input', {
        bubbles: true,
        cancelable: true,
        inputType: 'insertFromPaste',
        data: str
      }));
    } catch (err) {
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function dwNotifyContextBlock(wrap) {
    if (!wrap) return 'Back in stock notification';
    const ds = wrap.dataset;
    const productTitle = ds.dwNotifyProductTitle || data.productTitle || '';
    let variantTitle = ds.dwNotifyVariantTitle || '';
    if (variantTitle === 'Default Title') variantTitle = '';
    const lines = ['Back in stock notification'];
    if (productTitle) {
      lines.push(
        'Product: ' + productTitle + (variantTitle ? ' — ' + variantTitle : '')
      );
    }
    if (ds.dwNotifyProductUrl) lines.push('URL: ' + ds.dwNotifyProductUrl);
    if (ds.dwNotifyVariantId) lines.push('Variant ID: ' + ds.dwNotifyVariantId);
    if (ds.dwNotifySku) lines.push('SKU: ' + ds.dwNotifySku);
    if (ds.dwNotifyProductId) lines.push('Product ID: ' + ds.dwNotifyProductId);
    return lines.join('\n');
  }

  function dwNotifyNotesForSubmit(wrap, userNotes) {
    const context = dwNotifyContextBlock(wrap);
    const note = String(userNotes || '').trim();
    if (note) return note + '\n\n---\n' + context;
    return context;
  }

  function dwNotifyFindShadowEmail(shadow, slots) {
    if (slots && slots.email) return slots.email;
    if (!shadow) return null;
    const byType = shadow.querySelector('input[type="email"]');
    if (byType) return byType;
    const byAuto = shadow.querySelector('input[autocomplete="email"]');
    if (byAuto) return byAuto;
    const inputs = shadow.querySelectorAll('input');
    for (let i = 0; i < inputs.length; i++) {
      const field = inputs[i];
      const label = dwNotifyFieldLabel(field);
      if (label === 'email' || label === 'e-mail' || label === 'email address') return field;
    }
    return null;
  }

  function dwNotifySyncEmailToShadow(wrap, email) {
    const str = String(email || '').trim();
    if (!wrap || !str || !wrap._dwNotifyShadow) return false;
    dwNotifyRefreshSlots(wrap);
    const field = dwNotifyFindShadowEmail(wrap._dwNotifyShadow, wrap._dwNotifySlots);
    if (!field) return false;
    try {
      if (field.focus) field.focus({ preventScroll: true });
    } catch (e) {
      try { field.focus(); } catch (e2) {}
    }
    dwNotifySetFieldValue(field, str);
    if (!wrap._dwNotifySlots) wrap._dwNotifySlots = {};
    wrap._dwNotifySlots.email = field;
    return String(field.value || '').trim() === str;
  }

  function dwNotifyApplySlots(wrap, payload) {
    if (!wrap || !payload) return;
    dwNotifyRefreshSlots(wrap);
    const slots = wrap._dwNotifySlots;
    if (!slots) return;
    if (payload.email) dwNotifySyncEmailToShadow(wrap, payload.email);
    if (payload.product && slots.product) dwNotifySetFieldValue(slots.product, payload.product);
    if (payload.sku && slots.sku && payload.sku !== '—') dwNotifySetFieldValue(slots.sku, payload.sku);
    if (payload.productId && slots.productId) dwNotifySetFieldValue(slots.productId, String(payload.productId));
    if (payload.notes) {
      if (slots.notes) dwNotifySetFieldValue(slots.notes, payload.notes);
      else if (wrap._dwNotifyShadow) {
        const fallback = wrap._dwNotifyShadow.querySelector('textarea');
        if (fallback) dwNotifySetFieldValue(fallback, payload.notes);
      }
    }
  }

  function dwNotifyBindShadowSubmit(wrap, shadow, form) {
    if (!wrap || !shadow || !form || form.dataset.dwNotifyShadowBound === '1') return;
    form.dataset.dwNotifyShadowBound = '1';
    form.addEventListener('submit', function () {
      dwNotifyApplySlots(wrap, dwNotifyCollectPayload(wrap));
    }, true);
  }

  function dwNotifyResolveShadow(wrap) {
    const host = wrap && wrap.querySelector('[data-dw-notify-forms-host]');
    if (!host) return null;
    const embed = host.querySelector('shopify-forms-embed');
    const shadow = embed && embed.shadowRoot;
    const form = shadow && shadow.querySelector('form');
    if (!shadow || !form) return null;
    const slots = dwNotifyDiscoverSlots(shadow, wrap);
    wrap._dwNotifyShadow = shadow;
    wrap._dwNotifyForm = form;
    wrap._dwNotifySlots = slots;
    wrap.dataset.dwNotifyShadowReady = '1';
    dwNotifyBindShadowSubmit(wrap, shadow, form);
    return { shadow, form, slots };
  }

  function dwNotifyPrefill(wrap) {
    if (!wrap || !dwNotifyUsesShopifyForms()) return;

    function attempt() {
      const hit = dwNotifyResolveShadow(wrap);
      if (!hit) return false;
      dwNotifyApplySlots(wrap, dwNotifyCollectPayload(wrap));
      return true;
    }

    if (attempt()) return;

    let tries = 0;
    const maxTries = 80;
    let timer = null;
    timer = window.setInterval(function () {
      tries += 1;
      if (attempt() || tries >= maxTries) window.clearInterval(timer);
    }, 150);

    const host = wrap.querySelector('[data-dw-notify-forms-host]');
    if (host && !wrap._dwNotifyObserve) {
      wrap._dwNotifyObserve = true;
      try {
        new MutationObserver(function () {
          if (attempt()) window.clearInterval(timer);
        }).observe(host, { childList: true, subtree: true });
      } catch (e) {}
    }
  }

  function dwNotifyEnsureReady(wrap) {
    return new Promise(function (resolve, reject) {
      if (!wrap) {
        reject(new Error('no_wrap'));
        return;
      }
      if (wrap.dataset.dwNotifyShadowReady === '1' && wrap._dwNotifyForm) {
        resolve(wrap);
        return;
      }
      dwNotifyPrefill(wrap);
      let tries = 0;
      const timer = window.setInterval(function () {
        tries += 1;
        dwNotifyResolveShadow(wrap);
        if (wrap.dataset.dwNotifyShadowReady === '1' && wrap._dwNotifyForm) {
          window.clearInterval(timer);
          resolve(wrap);
          return;
        }
        if (tries >= 80) {
          window.clearInterval(timer);
          reject(new Error('not_ready'));
        }
      }, 150);
    });
  }

  function dwNotifySetStatus(wrap, message, kind) {
    const node = wrap && wrap.querySelector('[data-dw-notify-status]');
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
    node.classList.remove('is-success', 'is-error');
    if (kind === 'success') node.classList.add('is-success');
    if (kind === 'error') node.classList.add('is-error');
  }

  function dwNotifyCollectPayload(wrap) {
    const emailInput = wrap.querySelector('[data-dw-notify-input="email"]');
    const notesInput = wrap.querySelector('[data-dw-notify-input="notes"]');
    const email = emailInput ? String(emailInput.value || '').trim() : '';
    const userNotes = notesInput ? String(notesInput.value || '').trim() : '';
    const notes = dwNotifyNotesForSubmit(wrap, userNotes);
    const ds = wrap.dataset;
    const productEl = wrap.querySelector('[data-dw-notify-display="product"]');
    let product = productEl ? String(productEl.value || '').trim() : '';
    if (!product) product = ds.dwNotifyProductDisplay || '';
    const sku = ds.dwNotifySku || '';
    const productId = ds.dwNotifyProductId || (data.productId ? String(data.productId) : '');
    return { email, notes, product, sku, productId };
  }

  function dwNotifySubmitShopifyForm(wrap) {
    const payload = dwNotifyCollectPayload(wrap);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(payload.email)) {
      dwNotifySetStatus(wrap, 'Enter a valid email address.', 'error');
      wrap.querySelector('[data-dw-notify-input="email"]')?.focus();
      return;
    }

    const submitBtn = wrap.querySelector('#dw-pdp-notify-form button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
    }
    dwNotifyEnsureReady(wrap).then(function (readyWrap) {
      const shadow = readyWrap._dwNotifyShadow;
      const form = readyWrap._dwNotifyForm;
      const freshPayload = dwNotifyCollectPayload(readyWrap);

      let settled = false;
      function finish(kind, message) {
        if (settled) return;
        settled = true;
        if (submitBtn) {
          submitBtn.disabled = kind === 'success';
          submitBtn.textContent = kind === 'success' ? 'Submitted' : 'Notify me';
        }
        dwNotifySetStatus(wrap, message, kind);
      }

      form.addEventListener('submit', function () {
        window.setTimeout(function () {
          const errNodes = shadow.querySelectorAll('[class*="error"], [role="alert"]');
          let errText = '';
          errNodes.forEach(function (node) {
            const t = String(node.textContent || '').trim();
            if (t && t.length < 200) errText = t;
          });
          if (errText) {
            finish('error', errText);
            return;
          }
          const successCopy = wrap.getAttribute('data-dw-notify-success') ||
            'Thanks — we will email you when this item is back in stock.';
          finish('success', successCopy);
        }, 1200);
      }, { once: true });

      function send() {
        dwNotifyApplySlots(readyWrap, freshPayload);
        if (!dwNotifySyncEmailToShadow(readyWrap, freshPayload.email)) {
          finish('error', 'Enter a valid email address.');
          return;
        }
        try {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        } catch (err) {
          finish('error', 'Could not send your request. Try again.');
          return;
        }
        window.setTimeout(function () {
          if (settled) return;
          if (!dwNotifySyncEmailToShadow(readyWrap, freshPayload.email)) {
            finish('error', 'Enter a valid email address.');
            return;
          }
          finish('error', 'Could not send your request. Try again.');
        }, 1500);
      }

      dwNotifyApplySlots(readyWrap, freshPayload);
      window.requestAnimationFrame(function () {
        dwNotifySyncEmailToShadow(readyWrap, freshPayload.email);
        dwNotifyApplySlots(readyWrap, freshPayload);
        window.setTimeout(send, 100);
      });
    }).catch(function () {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify me';
      }
      dwNotifySetStatus(
        wrap,
        'Could not connect to the notify form. Close the window, wait a few seconds, and try again.',
        'error'
      );
    });
  }

  function updateVariantUI(variant) {
    if (!variant) return;

    // Hidden input for form
    const idInput = document.getElementById('dw-variant-id');
    if (idInput) idInput.value = variant.id;

    // Price
    const priceRow = document.getElementById('dw-price-row');
    if (priceRow) {
      const nowEl   = priceRow.querySelector('.dw-price-now');
      const wasEl   = priceRow.querySelector('.dw-price-was');
      const saveEl  = priceRow.querySelector('.dw-price-save');
      if (nowEl) {
        nowEl.dataset.basePrice = variant.price / 100;
        nowEl.dataset.variantPrice = variant.price / 100;
        nowEl.textContent = dwFormatMoney(variant.price);
      }
      if (wasEl)  wasEl.textContent  = variant.compare_at_price > variant.price ? dwFormatMoney(variant.compare_at_price) : '';
      if (saveEl) {
        if (variant.compare_at_price > variant.price) {
          const save = variant.compare_at_price - variant.price;
          saveEl.textContent = 'Save ' + dwFormatMoney(save);
          saveEl.style.display = '';
        } else {
          saveEl.style.display = 'none';
        }
      }
    }

    // Stock
    const stockLine = document.getElementById('dw-stock-line');
    if (stockLine) {
      if (variant.available) {
        const inStockMsg = data.inStockShippingMessage || 'In Stock — Ships within 1–2 business days';
        stockLine.innerHTML = '<span class="dw-stock-dot"></span> ' + inStockMsg;
        stockLine.style.color = 'var(--dw-green)';
      } else {
        stockLine.innerHTML = dwNotifyStockHtml();
        stockLine.style.color = 'var(--dw-red)';
      }
    }

    dwSyncAddButtonForAvailability(variant);
    dwSyncNotifyFormFields(variant);
    const notifyModal = document.getElementById('dw-notify-modal');
    if (notifyModal && !notifyModal.hidden) dwNotifyPrefill(dwNotifyFormWrap());

    // Add to cart button label fallback (dwSyncAddButtonForAvailability owns type/state)
    const cartBtn = document.getElementById('dw-add-btn');
    if (cartBtn && variant.available && cartBtn.textContent === 'Out of Stock') {
      cartBtn.textContent = 'Add to Cart';
    }

    dwEnsureContractorDisplay(variant.price);

    // Sticky bar
    const stickyPrice = document.getElementById('dw-sticky-price');
    const stickyLabel = document.getElementById('dw-sticky-variant-label');
    if (stickyPrice) stickyPrice.textContent = dwFormatMoney(variant.price);
    if (stickyLabel) stickyLabel.textContent = variant.title !== 'Default Title' ? variant.title : data.productTitle || '';

    // URL update (pushState)
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}

    // Calc update
    dwCalcDoors();
    dwUpdateBundleTotal();
    dwCheckCompat();

    // Dispatch event so custom options price can react
    document.dispatchEvent(new CustomEvent('dw:variantChanged', {
      detail: { price: variant.price, variant: variant },
      bubbles: true
    }));
  }

  /* ── OPTION: FINISH SWATCHES ── */
  document.querySelectorAll('.dw-sw-item').forEach(el => {
    el.addEventListener('click', () => {
      const value = el.dataset.value;
      document.querySelectorAll('.dw-sw-item').forEach(s => {
        s.classList.remove('on');
        s.setAttribute('aria-checked', 'false');
      });
      el.classList.add('on');
      el.setAttribute('aria-checked', 'true');
      selected.option1 = value;
      el.closest('.dw-sel-block')?.classList.remove('dw-option-error');

      // Update UI labels
      const nameEl = document.getElementById('dw-finish-name');
      if (nameEl) nameEl.textContent = '— ' + value;
      const overlayEl = document.getElementById('dw-finish-overlay');
      if (overlayEl) overlayEl.textContent = value;

      // Find variant image for this finish
      dwUpdateGalleryForFinish(value);

      const v = findVariant();
      if (v) updateVariantUI(v);
    });

    // Keyboard support
    el.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
    });
  });

  /* ── OPTION: FUNCTION PILLS ── */
  document.querySelectorAll('.dw-func-pill').forEach(el => {
    el.addEventListener('click', () => {
      document.querySelectorAll('.dw-func-pill').forEach(p => {
        p.classList.remove('on');
        p.setAttribute('aria-checked', 'false');
      });
      el.classList.add('on');
      el.setAttribute('aria-checked', 'true');
      selected.option2 = el.dataset.value;
      el.closest('.dw-sel-block')?.classList.remove('dw-option-error');

      const v = findVariant();
      if (v) updateVariantUI(v);
      dwCheckCompat();
    });

    el.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
    });
  });

  /* ── OPTION: DOOR THICKNESS ── */
  const thickSelect = document.getElementById('dw-thickness');
  if (thickSelect) {
    thickSelect.addEventListener('change', () => {
      selected.option3 = thickSelect.value;
      const v = findVariant();
      if (v) updateVariantUI(v);
      dwCheckCompat();
    });
  }

  /* ── GALLERY: main image swap (src + srcset must stay in sync) ── */
  function dwSrcsetFromShopifyUrl(url) {
    if (!url) return '';
    if (/width=\d+/.test(url)) {
      return [400, 800, 1200]
        .map((w) => url.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w')
        .join(', ');
    }
    return '';
  }

  function dwSetMainGalleryImage(mainImg, url, alt, zoomUrl) {
    if (!mainImg || !url) return;
    const srcset = dwSrcsetFromShopifyUrl(url);
    const apply = () => {
      mainImg.src = url;
      if (srcset) mainImg.srcset = srcset;
      else mainImg.removeAttribute('srcset');
      if (alt) mainImg.alt = alt;
      if (zoomUrl) mainImg.dataset.zoomSrc = zoomUrl;
      if (typeof window.dwGalleryZoomSync === 'function') {
        window.dwGalleryZoomSync();
      }
    };
    const probe = new Image();
    probe.decoding = 'async';
    if (srcset) {
      probe.srcset = srcset;
      probe.sizes = mainImg.getAttribute('sizes') || '(max-width: 768px) 100vw, 560px';
    }
    probe.src = url;
    const done = () => apply();
    if (typeof probe.decode === 'function') {
      probe.decode().then(done).catch(done);
    } else if (probe.complete) {
      done();
    } else {
      probe.onload = done;
      probe.onerror = done;
    }
  }

  /* ── GALLERY: update image when finish changes ── */
  function dwUpdateGalleryForFinish(finishValue) {
    const thumbs = document.querySelectorAll('.dw-thumb');
    let matched = null;
    thumbs.forEach(t => {
      const label = (t.dataset.label || '').toLowerCase();
      if (label.includes(finishValue.toLowerCase().split(' ')[0])) {
        matched = t;
      }
    });
    if (matched) matched.click();
  }

  /* ── THUMBNAIL GALLERY ── */
  function dwWarmThumb(url) {
    if (!url) return;
    const probe = new Image();
    probe.decoding = 'async';
    probe.src = url;
  }

  document.querySelectorAll('.dw-thumb').forEach(t => {
    t.addEventListener('pointerenter', () => {
      dwWarmThumb(t.dataset.imgSrc);
      dwWarmThumb(t.dataset.zoomSrc);
    }, { passive: true });
    t.addEventListener('pointerdown', () => {
      dwWarmThumb(t.dataset.imgSrc);
      dwWarmThumb(t.dataset.zoomSrc);
    }, { passive: true });
    t.addEventListener('click', () => {
      document.querySelectorAll('.dw-thumb').forEach(th => {
        th.classList.remove('on');
        th.setAttribute('aria-pressed', 'false');
      });
      t.classList.add('on');
      t.setAttribute('aria-pressed', 'true');

      const mainImg   = document.getElementById('dw-main-img');
      const overlayEl = document.getElementById('dw-finish-overlay');
      if (mainImg && t.dataset.imgSrc) {
        dwSetMainGalleryImage(mainImg, t.dataset.imgSrc, t.dataset.label, t.dataset.zoomSrc);
      }
      if (overlayEl && t.dataset.label) {
        overlayEl.textContent = t.dataset.label;
      }
    });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      document.querySelectorAll('.dw-thumb').forEach((t) => {
        dwWarmThumb(t.dataset.imgSrc);
        dwWarmThumb(t.dataset.zoomSrc);
      });
    }, { timeout: 2000 });
  }

  /* ── GALLERY MAGNIFY ZOOM: hover (desktop) / tap (mobile) ── */
  (function dwInitGalleryZoom() {
    const wrap = document.getElementById('dw-main-img-wrap');
    const mainImg = document.getElementById('dw-main-img');
    let pane = document.getElementById('dw-zoom-pane');
    if (!wrap || !mainImg) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!pane) {
      pane = document.createElement('div');
      pane.className = 'dw-zoom-pane';
      pane.id = 'dw-zoom-pane';
      pane.hidden = true;
      pane.setAttribute('aria-hidden', 'true');
      wrap.appendChild(pane);
    }

    const ZOOM = 2.4;
    const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    let active = false;
    let pinnedOff = false; // desktop: click while zoomed dismisses until leave or click again
    let zoomUrl = '';

    wrap.setAttribute('data-dw-zoom', '');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', 'Product image — hover to magnify, click to toggle');

    function currentZoomUrl() {
      return mainImg.dataset.zoomSrc || mainImg.currentSrc || mainImg.src || '';
    }

    function setPaneImage(url) {
      if (!url || url === zoomUrl) return;
      zoomUrl = url;
      pane.style.backgroundImage = 'url("' + url.replace(/"/g, '\\"') + '")';
      pane.style.backgroundSize = (ZOOM * 100) + '%';
      dwWarmThumb(url);
    }

    function layoutPane() {
      const wrapRect = wrap.getBoundingClientRect();
      const imgRect = mainImg.getBoundingClientRect();
      if (!wrapRect.width || !imgRect.width) {
        pane.style.inset = '0';
        pane.style.width = '';
        pane.style.height = '';
        return;
      }
      pane.style.inset = 'auto';
      pane.style.left = (imgRect.left - wrapRect.left) + 'px';
      pane.style.top = (imgRect.top - wrapRect.top) + 'px';
      pane.style.width = imgRect.width + 'px';
      pane.style.height = imgRect.height + 'px';
    }

    function overImage(clientX, clientY) {
      const rect = mainImg.getBoundingClientRect();
      if (!rect.width || !rect.height) return false;
      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
    }

    function setOrigin(clientX, clientY) {
      const rect = pane.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const x = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      const y = Math.min(100, Math.max(0, ((clientY - rect.top) / rect.height) * 100));
      pane.style.backgroundPosition = x + '% ' + y + '%';
    }

    function startZoom(clientX, clientY) {
      setPaneImage(currentZoomUrl());
      if (!zoomUrl) return;
      layoutPane();
      active = true;
      pinnedOff = false;
      wrap.classList.add('is-zooming');
      pane.hidden = false;
      if (clientX != null && clientY != null) setOrigin(clientX, clientY);
      else pane.style.backgroundPosition = '50% 50%';
    }

    function stopZoom() {
      if (!active) return;
      active = false;
      wrap.classList.remove('is-zooming');
      pane.hidden = true;
    }

    function syncZoom() {
      const next = currentZoomUrl();
      if (active) {
        setPaneImage(next);
        layoutPane();
      } else {
        zoomUrl = '';
        if (next) dwWarmThumb(next);
      }
    }
    window.dwGalleryZoomSync = syncZoom;

    wrap.addEventListener('pointerenter', () => {
      setPaneImage(currentZoomUrl());
    }, { passive: true });

    wrap.addEventListener('pointermove', (e) => {
      if (!fineHover.matches) {
        if (active) setOrigin(e.clientX, e.clientY);
        return;
      }
      if (!overImage(e.clientX, e.clientY)) {
        stopZoom();
        return;
      }
      if (pinnedOff) return;
      if (!active) startZoom(e.clientX, e.clientY);
      else setOrigin(e.clientX, e.clientY);
    });

    wrap.addEventListener('pointerleave', () => {
      if (!fineHover.matches) return;
      stopZoom();
      pinnedOff = false;
    });

    wrap.addEventListener('click', (e) => {
      if (e.target.closest('.dw-thumb')) return;
      if (!overImage(e.clientX, e.clientY) && !active) return;
      e.preventDefault();

      if (fineHover.matches) {
        // Desktop: hover zooms in; click toggles zoom out / back on
        if (active) {
          stopZoom();
          pinnedOff = true;
        } else {
          startZoom(e.clientX, e.clientY);
        }
        return;
      }

      if (active) stopZoom();
      else startZoom(e.clientX, e.clientY);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (active) {
        stopZoom();
        if (fineHover.matches) pinnedOff = true;
      }
    });

    syncZoom();
  })();

  function dwClearPdpValidation(form) {
    if (!form) return;
    form.querySelectorAll('.dw-select-error').forEach((el) => el.classList.remove('dw-select-error'));
    form.querySelectorAll('.dw-option-error').forEach((el) => el.classList.remove('dw-option-error'));
    form.querySelectorAll('.dw-custom-input-msg').forEach((el) => {
      el.textContent = '';
      el.hidden = true;
    });
  }

  function dwSelectNeedsAtcValidation(sel) {
    if (!sel || sel.disabled) return false;
    if (sel.id === 'dw-thickness' || sel.id === 'dw-backset') return false;
    return sel.hasAttribute('required') || sel.classList.contains('dw-custom-option-select');
  }

  function dwSelectHasChosen(sel) {
    if (!sel || sel.disabled) return true;
    const idx = sel.selectedIndex;
    if (idx < 0) return false;
    const opt = sel.options[idx];
    if (!opt || opt.disabled) return false;
    return String(opt.value || '').trim() !== '';
  }

  function dwParseMeasure(raw) {
    if (raw == null) return NaN;
    let s = String(raw).replace(/[″”]/g, '"').trim();
    if (!s) return NaN;
    s = s.replace(/\s*(inches?|in)\.?$/i, '').trim();
    const mixed = s.match(/^(-?\d+(?:\.\d+)?)\s*[-\s]\s*(\d+)\s*\/\s*(\d+)\s*"?\s*$/);
    if (mixed) {
      const den = parseFloat(mixed[3]);
      if (!den) return NaN;
      return parseFloat(mixed[1]) + parseFloat(mixed[2]) / den;
    }
    const frac = s.match(/^(-?\d+)\s*\/\s*(\d+)\s*"?\s*$/);
    if (frac) {
      const den = parseFloat(frac[2]);
      if (!den) return NaN;
      return parseFloat(frac[1]) / den;
    }
    const num = s.match(/-?\d+(?:\.\d+)?/);
    if (!num) return NaN;
    return parseFloat(num[0]);
  }

  function dwBoundsFromHint(hint) {
    const s = String(hint || '');
    const out = { min: NaN, max: NaN, minLabel: '', maxLabel: '' };
    const between = s.match(/between\s+([^,]+?)\s+and\s+([^\s,;]+)/i);
    if (between) {
      out.minLabel = between[1].trim();
      out.maxLabel = between[2].replace(/[.;]+$/, '').trim();
      out.min = dwParseMeasure(out.minLabel);
      out.max = dwParseMeasure(out.maxLabel);
    }
    const maxM = s.match(/\bmax(?:imum)?(?:\s+(?:of|material\s+size))?\s*[:=]?\s*([0-9][\d.\-\/ ]*"?)/i);
    const minM = s.match(/\bmin(?:imum)?(?:\s+of)?\s*[:=]?\s*([0-9][\d.\-\/ ]*"?)/i);
    const upTo = s.match(/\bup to\s+([0-9][\d.\-\/ ]*"?)/i);
    if (!Number.isFinite(out.max) && maxM) {
      out.maxLabel = maxM[1].trim();
      out.max = dwParseMeasure(out.maxLabel);
    }
    if (!Number.isFinite(out.max) && upTo) {
      out.maxLabel = upTo[1].trim();
      out.max = dwParseMeasure(out.maxLabel);
    }
    if (!Number.isFinite(out.min) && minM) {
      out.minLabel = minM[1].trim();
      out.min = dwParseMeasure(out.minLabel);
    }
    return out;
  }

  function dwCustomInputBounds(opt) {
    const hint = dwBoundsFromHint(opt && opt.dataset ? opt.dataset.inputHint : '');
    const minAttr = opt && opt.dataset ? String(opt.dataset.inputMin || '').trim() : '';
    const maxAttr = opt && opt.dataset ? String(opt.dataset.inputMax || '').trim() : '';
    const min = dwParseMeasure(minAttr);
    const max = dwParseMeasure(maxAttr);
    return {
      min: Number.isFinite(min) ? min : hint.min,
      max: Number.isFinite(max) ? max : hint.max,
      minLabel: minAttr || hint.minLabel,
      maxLabel: maxAttr || hint.maxLabel,
    };
  }

  function dwFillBoundMsg(tpl, bounds) {
    return String(tpl || '')
      .replace(/%min%/g, bounds.minLabel || String(bounds.min))
      .replace(/%max%/g, bounds.maxLabel || String(bounds.max));
  }

  function dwSetCustomInputMessage(input, message) {
    if (!input) return;
    const wrap = input.closest('.dw-custom-input-wrap');
    const msg = wrap && wrap.querySelector('.dw-custom-input-msg');
    if (!msg) return;
    if (message) {
      msg.textContent = message;
      msg.hidden = false;
    } else {
      msg.textContent = '';
      msg.hidden = true;
    }
  }

  function dwValidateCustomInput(input, opt) {
    if (!input) return { ok: false, message: '' };
    const wrap = input.closest('.dw-custom-input-wrap');
    const msgs = (wrap && wrap.dataset) || {};
    const raw = String(input.value || '').trim();
    if (!raw) {
      return { ok: false, message: msgs.msgRequired || 'Enter a custom value' };
    }
    const bounds = dwCustomInputBounds(opt);
    const hasBounds = Number.isFinite(bounds.min) || Number.isFinite(bounds.max);
    if (!hasBounds) return { ok: true, message: '' };
    const n = dwParseMeasure(raw);
    if (!Number.isFinite(n)) {
      return { ok: false, message: msgs.msgInvalid || 'Enter a valid measurement' };
    }
    if (Number.isFinite(bounds.min) && Number.isFinite(bounds.max) && (n < bounds.min || n > bounds.max)) {
      return { ok: false, message: dwFillBoundMsg(msgs.msgRange, bounds) };
    }
    if (Number.isFinite(bounds.min) && n < bounds.min) {
      return { ok: false, message: dwFillBoundMsg(msgs.msgMin, bounds) };
    }
    if (Number.isFinite(bounds.max) && n > bounds.max) {
      return { ok: false, message: dwFillBoundMsg(msgs.msgMax, bounds) };
    }
    return { ok: true, message: '' };
  }

  function dwValidatePdpForm(form) {
    if (!form) return null;
    let firstInvalid = null;
    const mark = (el) => {
      if (!firstInvalid && el) firstInvalid = el;
    };

    dwClearPdpValidation(form);

    const sw = form.querySelector('.dw-swatches');
    if (sw && sw.querySelectorAll('.dw-sw-item').length && !sw.querySelector('.dw-sw-item.on')) {
      const sb = sw.closest('.dw-sel-block');
      if (sb) sb.classList.add('dw-option-error');
      mark(sw.querySelector('.dw-sw-item'));
    }

    const fp = form.querySelector('.dw-func-pills');
    if (fp && fp.querySelectorAll('.dw-func-pill').length && !fp.querySelector('.dw-func-pill.on')) {
      const sb = fp.closest('.dw-sel-block');
      if (sb) sb.classList.add('dw-option-error');
      mark(fp.querySelector('.dw-func-pill'));
    }

    form.querySelectorAll('select').forEach((sel) => {
      if (!dwSelectNeedsAtcValidation(sel)) return;
      if (!dwSelectHasChosen(sel)) {
        sel.classList.add('dw-select-error');
        const thumbWrap = sel.closest('.dw-custom-select--thumb');
        if (thumbWrap) thumbWrap.classList.add('dw-select-error');
        const trigger = thumbWrap && thumbWrap.querySelector('.dw-img-select__trigger');
        mark(trigger || sel);
        return;
      }
      const opt = sel.options[sel.selectedIndex];
      if (opt && opt.dataset.allowsCustomInput === 'true') {
        const input = dwCustomInputForSelect(sel);
        const check = dwValidateCustomInput(input, opt);
        if (!check.ok) {
          if (input) {
            input.classList.add('dw-select-error');
            dwSetCustomInputMessage(input, check.message);
          }
          sel.closest('.dw-sel-block')?.classList.add('dw-option-error');
          mark(input || sel);
        }
      }
    });

    return firstInvalid;
  }

  function dwShowAtcValidationFailed(btn, firstInvalid) {
    const thumbWrap = firstInvalid && firstInvalid.closest && firstInvalid.closest('.dw-custom-select--thumb');
    const trigger = thumbWrap && thumbWrap.querySelector('.dw-img-select__trigger');
    if (trigger) {
      trigger.focus();
      trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (firstInvalid && firstInvalid.focus) {
      firstInvalid.focus();
      if (firstInvalid.scrollIntoView) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (btn) {
      btn.textContent = 'Please complete all required options';
      btn.style.background = 'var(--dw-red)';
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.style.background = '';
      }, 2500);
    }
  }

  /**
   * Cart: visible property = human label (native checkout → order).
   * _handle_* / _mod_* / _doorware_base = API + pricing only (underscore keys).
   */
  function dwFormatOptionCartDisplay(display, mod) {
    if (!display) return '';
    if (!isNaN(mod) && mod !== 0) {
      return display + ' (+$' + mod.toFixed(2) + ')';
    }
    return display;
  }

  function dwSetOptionCartProperties(properties, label, opt, customText) {
    const handle = String(opt.value || '').trim();
    if (!label || !handle || handle.startsWith('{')) return;
    const filled = String(customText || '').trim();
    const displayBase = filled
      || (opt.dataset.optionDisplay || opt.textContent || '')
          .replace(/\s*\(\+[\s\S]*$/, '')
          .trim();
    const mod = parseFloat(opt.dataset.priceModifier || opt.dataset.priceImpact || '');
    properties['_handle_' + label] = handle;
    properties[label] = displayBase
      ? dwFormatOptionCartDisplay(displayBase, mod)
      : handle;
    if (!isNaN(mod) && mod !== 0) properties['_mod_' + label] = String(mod);
  }

  function dwCustomInputForSelect(sel) {
    if (!sel) return null;
    const block = sel.closest('.dw-sel-block, .custom-option-group, .dw-master-choices-wrap');
    if (!block) return null;
    return block.querySelector('.dw-custom-option-input');
  }

  function dwSyncCustomInputVisibility(sel) {
    if (!sel) return;
    const wrap = sel.closest('.dw-sel-block, .custom-option-group');
    const inputWrap = wrap ? wrap.querySelector('.dw-custom-input-wrap') : null;
    const input = inputWrap ? inputWrap.querySelector('.dw-custom-option-input') : null;
    if (!inputWrap || !input) return;
    const opt = sel.options[sel.selectedIndex];
    const allow = !!(opt && opt.dataset.allowsCustomInput === 'true');
    inputWrap.hidden = !allow;
    if (wrap) wrap.classList.toggle('is-custom-input', allow);
    if (allow) {
      const hint = (opt.dataset.inputHint || '').trim();
      if (hint) input.placeholder = hint;
      input.required = true;
      const bounds = dwCustomInputBounds(opt);
      input.inputMode = (Number.isFinite(bounds.min) || Number.isFinite(bounds.max)) ? 'decimal' : '';
      dwSetCustomInputMessage(input, '');
    } else {
      input.required = false;
      input.value = '';
      input.inputMode = '';
      input.classList.remove('dw-select-error');
      dwSetCustomInputMessage(input, '');
    }
  }

  /* ────────────────────────────────────────
     ADD TO CART (AJAX)
  ──────────────────────────────────────── */

  const form = document.getElementById('add-to-cart-form');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = document.getElementById('dw-add-btn');

      const firstInvalid = dwValidatePdpForm(form);
      if (firstInvalid) {
        dwShowAtcValidationFailed(btn, firstInvalid);
        return;
      }

      const qty = parseInt(document.getElementById('dw-qty')?.value || 1);
      const variantId = document.getElementById('dw-variant-id')?.value;
      const backset  = document.getElementById('dw-backset')?.value || '';

      if (!variantId) return;

      // Collect custom option properties
      const properties = {};
      if (backset) properties['Backset'] = backset;

      form.querySelectorAll('.dw-custom-option-select').forEach(sel => {
        const label = sel.dataset.optionLabel || '';
        const opt = sel.options[sel.selectedIndex];
        if (!opt || !opt.value) return;
        const customInput = dwCustomInputForSelect(sel);
        const customText =
          opt.dataset.allowsCustomInput === 'true' && customInput
            ? String(customInput.value || '').trim()
            : '';
        dwSetOptionCartProperties(properties, label, opt, customText);
      });

      // Add _doorware_base for backend draft order pricing
      const pData = window.dwProductData || {};
      const variantIdNum = parseInt(variantId, 10);
      const activeVariant = (pData.variants || []).find((v) => v.id === variantIdNum);
      const priceCents = activeVariant ? activeVariant.price : pData.price;
      if (priceCents != null) {
        const baseDollars = priceCents / 100;
        properties['_doorware_base'] = JSON.stringify({ base_price: baseDollars });
      }

      btn.textContent = 'Adding…';
      btn.disabled = true;

      const body = {
        items: [{
          id: parseInt(variantId),
          quantity: qty,
          properties: properties
        }]
      };

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        });

        if (!res.ok) throw new Error('Cart error');
        await res.json();

        btn.textContent = '✓ Added to Cart';
        btn.style.background = 'var(--dw-ink)';
        dwUpdateCartCount(qty);
        dwOpenCartSlider();

        setTimeout(() => {
          btn.textContent = 'Add to Cart';
          btn.style.background = '';
          btn.disabled = false;
        }, 2200);

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: body, bubbles: true }));

      } catch (err) {
        btn.textContent = 'Error — Try Again';
        btn.style.background = 'var(--dw-red)';
        btn.disabled = false;
        setTimeout(() => { btn.textContent = 'Add to Cart'; btn.style.background = ''; }, 2500);
      }
    });
  }

  /* ── STICKY ADD TO CART ── */
  window.dwStickyAddToCart = function () {
    const addBtn = document.getElementById('dw-add-btn');
    const stickyBtn = document.getElementById('dw-sticky-add-btn');
    if ((addBtn && addBtn.getAttribute('data-dw-notify') === 'true') ||
        (stickyBtn && stickyBtn.getAttribute('data-dw-notify') === 'true')) {
      dwOpenNotifyModal();
      return;
    }
    if (addBtn) addBtn.click();
  };

  /* ── CART SLIDER ── */
  var _dwSliderTimer = null;
  function dwOpenCartSlider() {
    function openSlider() {
      if (window.DwMobileDrawer && typeof window.DwMobileDrawer.open === 'function') {
        window.DwMobileDrawer.open('cart');
      }
    }

    function refreshAndOpen(retries) {
      fetch('/cart.js?t=' + Date.now(), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var badge = document.querySelector('.cart-count');
          var expected = badge ? parseInt(badge.textContent) || 0 : 0;
          if (cart.item_count < expected && retries > 0) {
            setTimeout(function () { refreshAndOpen(retries - 1); }, 500);
            return;
          }
          try {
            if (typeof mt !== 'undefined' && mt._headercartitem) {
              mt._headercartitem(cart);
            }
          } catch (e) {}
          openSlider();
        })
        .catch(function () { openSlider(); });
    }

    if (_dwSliderTimer) clearTimeout(_dwSliderTimer);
    _dwSliderTimer = setTimeout(function () {
      _dwSliderTimer = null;
      refreshAndOpen(3);
    }, 1000);
  }

  /* ── CART COUNT ── */
  function dwUpdateCartCount(addedQty) {
    // Update any cart count badge in the header
    const badge = document.querySelector('[data-cart-count], .dw-cart-badge, .cart-badge, .cart-count');
    if (badge) {
      const current = parseInt(badge.textContent) || 0;
      badge.textContent = current + addedQty;
    }
    // Fetch fresh count from Shopify
    fetch('/cart.js').then(r => r.json()).then(cart => {
      const badges = document.querySelectorAll('[data-cart-count], .dw-cart-badge, .cart-badge, .cart-count');
      badges.forEach(b => b.textContent = cart.item_count);
    }).catch(() => {});
  }

  /* ────────────────────────────────────────
     BUNDLE ADD TO CART
  ──────────────────────────────────────── */

  window.dwToggleBundle = function (el) {
    el.classList.toggle('checked');
    el.setAttribute('aria-checked', el.classList.contains('checked') ? 'true' : 'false');
    dwUpdateBundleTotal();
  };

  window.dwUpdateBundleTotal = function () {
    const variantPrice = (findVariant()?.price || data.price || 0) / 100;
    let total = variantPrice;
    let extras = 0;

    document.querySelectorAll('.dw-bundle-item.checked').forEach(item => {
      total += parseFloat(item.dataset.price || 0);
      extras++;
    });

    const totalEl = document.getElementById('dw-bundle-total');
    if (totalEl) totalEl.textContent = dwFormatMoney(Math.round(total * 100));

    const tagEl = document.getElementById('dw-bundle-tag');
    if (tagEl) {
      if (extras === 0) tagEl.textContent = 'Add items, save 10%';
      else if (extras === 1) tagEl.textContent = 'Saving ~10% vs. buying separately';
      else tagEl.textContent = `Saving ~${Math.min(10 + extras * 3, 20)}% vs. buying separately`;
    }
  };

  window.dwAddBundle = async function () {
    const form = document.getElementById('add-to-cart-form');
    const firstInvalid = form ? dwValidatePdpForm(form) : null;
    const btn = document.getElementById('dw-bundle-btn');
    if (firstInvalid) {
      if (btn) {
        btn.textContent = 'Please complete all required options';
        btn.style.background = 'var(--dw-red)';
        setTimeout(() => {
          btn.textContent = 'Add Bundle to Cart';
          btn.style.background = '';
        }, 2500);
      }
      const thumbWrap = firstInvalid.closest && firstInvalid.closest('.dw-custom-select--thumb');
      const trigger = thumbWrap && thumbWrap.querySelector('.dw-img-select__trigger');
      if (trigger) {
        trigger.focus();
        trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (firstInvalid.focus) {
        firstInvalid.focus();
        if (firstInvalid.scrollIntoView) firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    const variantId = document.getElementById('dw-variant-id')?.value;
    const qty = parseInt(document.getElementById('dw-qty')?.value || 1);
    if (!variantId) return;
    if (!btn) return;

    btn.textContent = 'Adding…';
    btn.disabled = true;

    const items = [{ id: parseInt(variantId), quantity: qty }];
    document.querySelectorAll('.dw-bundle-item.checked').forEach(item => {
      if (item.dataset.variantId) {
        items.push({ id: parseInt(item.dataset.variantId), quantity: 1 });
      }
    });

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error();
      btn.textContent = '✓ Bundle Added!';
      dwUpdateCartCount(items.length);
      dwOpenCartSlider();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(() => { btn.textContent = 'Add Bundle to Cart'; btn.disabled = false; }, 2200);
    } catch {
      btn.textContent = 'Error — Try Again';
      btn.disabled = false;
      setTimeout(() => { btn.textContent = 'Add Bundle to Cart'; }, 2500);
    }
  };

  /* ── RELATED: QUICK ADD ── */
  window.dwQuickAdd = async function (btn, variantId) {
    const orig = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      });
      if (!res.ok) throw new Error();
      btn.textContent = '✓ Added!';
      dwUpdateCartCount(1);
      dwOpenCartSlider();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 2000);
    } catch {
      btn.textContent = 'Error'; btn.disabled = false;
      setTimeout(() => { btn.textContent = orig; }, 2000);
    }
  };

  /* ────────────────────────────────────────
     DOOR CALCULATOR
  ──────────────────────────────────────── */

  window.dwChangeDoors = function (delta) {
    const input = document.getElementById('dw-door-count');
    if (!input) return;
    let v = parseInt(input.value) + delta;
    if (v < 1) v = 1;
    input.value = v;
    dwCalcDoors();
  };

  window.dwCalcDoors = function () {
    const doors   = parseInt(document.getElementById('dw-door-count')?.value || 1);
    const result  = document.getElementById('dw-dc-result');
    const qtyInput = document.getElementById('dw-qty');
    if (!result) return;

    if (doors > 1) {
      const variant  = findVariant();
      const price    = (variant?.price || data.price || 0) / 100;
      const total    = (doors * price).toFixed(2);
      const funcPill = document.querySelector('.dw-func-pill.on .dw-fp-name');
      const funcName = funcPill ? funcPill.textContent.split(' (')[0] : 'units';

      result.textContent = `${doors}× ${funcName} — Est. total: $${total}`;
      result.classList.add('show');
      if (qtyInput) qtyInput.value = doors;
    } else {
      result.classList.remove('show');
      if (qtyInput && qtyInput.value > 1) qtyInput.value = 1;
    }
  };

  /* ────────────────────────────────────────
     COMPATIBILITY WARNING
  ──────────────────────────────────────── */

  window.dwCheckCompat = function () {
    const warn    = document.getElementById('dw-compat-warn');
    const msg     = document.getElementById('dw-compat-msg');
    if (!warn || !msg) return;

    const funcPill = document.querySelector('.dw-func-pill.on');
    const funcKey  = funcPill?.dataset.funcKey || '';
    const thick    = document.getElementById('dw-thickness')?.value || '';
    const phone    = data.phone || '954-776-5340';

    let warning = '';

    if ((funcKey.includes('privacy')) && thick.includes('1-3/8')) {
      warning = `Privacy function works best on 1-3/4" or thicker doors. A 1-3/8" door may require an extended latch. Call us to confirm: ${phone}.`;
    } else if ((funcKey.includes('double-dummy')) && thick.includes('2-inch')) {
      warning = `For 2" doors with Double Dummy, you may need extended through-bolts. Contact us to confirm: ${phone}.`;
    } else if ((funcKey.includes('keyed') || funcKey.includes('entry')) && thick.includes('1-3/8')) {
      warning = `Keyed entry function typically requires a 1-3/4" door for optimal security. Please confirm your door thickness before ordering.`;
    }

    if (warning) {
      msg.textContent = warning;
      warn.classList.add('show');
    } else {
      warn.classList.remove('show');
    }
  };

  /* ── BACKSET GUIDE MODAL ── */
  window.dwShowBacksetGuide = function () {
    if (document.getElementById('dw-backset-modal')) {
      document.getElementById('dw-backset-modal').style.display = 'flex';
      return;
    }
    const modal = document.createElement('div');
    modal.id = 'dw-backset-modal';
    modal.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px';
    modal.innerHTML = `
      <div style="background:#fff;border-radius:8px;padding:28px;max-width:480px;width:100%;position:relative;font-family:inherit">
        <button onclick="document.getElementById('dw-backset-modal').style.display='none'"
                style="position:absolute;top:14px;right:14px;background:none;border:none;font-size:20px;cursor:pointer;color:#999">✕</button>
        <h3 style="font-size:16px;font-weight:600;margin-bottom:12px">What is a Backset?</h3>
        <p style="font-size:13.5px;color:#5C5C58;line-height:1.65;margin-bottom:14px">
          The <strong>backset</strong> is the distance from the edge of your door to the center of the bore hole (the large round hole where the lever installs).
        </p>
        <p style="font-size:13.5px;color:#5C5C58;line-height:1.65;margin-bottom:8px">
          <strong>2-3/8"</strong> — Most common on interior doors and older homes.<br>
          <strong>2-3/4"</strong> — Common on newer construction and exterior doors.
        </p>
        <p style="font-size:12.5px;color:#9A9A94">Measure from the door edge to the center of the existing hole, or check your current hardware. Not sure? Call us: ${data.phone || '954-776-5340'}</p>
      </div>`;
    document.body.appendChild(modal);
    modal.addEventListener('click', e => { if (e.target === modal) modal.style.display = 'none'; });
  };

  /* ────────────────────────────────────────
     QUANTITY
  ──────────────────────────────────────── */

  window.dwChangeQty = function (delta) {
    const input = document.getElementById('dw-qty');
    if (!input) return;
    let v = parseInt(input.value) + delta;
    if (v < 1) v = 1;
    input.value = v;
  };

  /* ────────────────────────────────────────
     TABS
  ──────────────────────────────────────── */

  window.dwSwitchTab = function (id, btn) {
    document.querySelectorAll('.dw-tc').forEach(t => t.classList.remove('on'));
    document.querySelectorAll('.dw-tb').forEach(b => {
      b.classList.remove('on');
      b.setAttribute('aria-selected', 'false');
    });

    const panel = document.getElementById(id);
    if (panel) panel.classList.add('on');

    if (btn) {
      btn.classList.add('on');
      btn.setAttribute('aria-selected', 'true');
    } else {
      // Called from a link — find matching button
      document.querySelectorAll('.dw-tb').forEach(b => {
        if (b.getAttribute('aria-controls') === id) {
          b.classList.add('on');
          b.setAttribute('aria-selected', 'true');
        }
      });
    }

    const tabsWrap = document.querySelector('.dw-tabs-wrap');
    if (tabsWrap) {
      const y = tabsWrap.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  /* ────────────────────────────────────────
     PDP CONTACT FORM — open Contact tab after successful native submit
  ──────────────────────────────────────── */

  const dwPdpContactForm = document.getElementById('dw-pdp-contact-form');
  const dwPdpContactPosted =
    /(?:^|[?&])contact_posted=true(?:&|$)/.test(window.location.search) ||
    !!(dwPdpContactForm && dwPdpContactForm.querySelector('.form-success'));
  if (dwPdpContactForm && dwPdpContactPosted) {
    if (typeof window.dwSwitchTab === 'function') {
      window.dwSwitchTab('tab-qa');
    }
    const dwPdpContactOk = dwPdpContactForm.querySelector('.form-success');
    if (dwPdpContactOk && dwPdpContactOk.scrollIntoView) {
      dwPdpContactOk.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  /* ────────────────────────────────────────
     STICKY CTA: show after gallery scrolls out
  ──────────────────────────────────────── */

  const stickyCta  = document.getElementById('dw-sticky-buy');
  const galleryEl  = document.getElementById('dw-gallery');

  if (stickyCta && galleryEl) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyCta.style.display = 'flex';
        } else {
          stickyCta.style.display = 'none';
        }
      });
    }, { threshold: 0 });
    obs.observe(galleryEl);
  }

  /* ────────────────────────────────────────
     UTILITIES
  ──────────────────────────────────────── */

  function dwFormatMoney(cents) {
    const format = window.money_format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    const amount = (cents / 100).toFixed(2);
    return window.dwPresentmentCurrency === 'CAD' ? '$' + amount + ' CAD' : '$' + amount;
  }

  /* ── Run on load ── */
  dwUpdateBundleTotal();
  dwCheckCompat();

  /* ── CUSTOM OPTIONS: thumbnail listbox + hidden native select ── */
  function dwCloseThumbPanel(wrap) {
    if (!wrap) return;
    const panel = wrap.querySelector('.dw-img-select__panel');
    const trigger = wrap.querySelector('.dw-img-select__trigger');
    if (panel && !panel.hidden) {
      panel.hidden = true;
      wrap.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
  }

  function dwCloseAllThumbPanels(exceptWrap) {
    document.querySelectorAll('.dw-custom-select--thumb').forEach(w => {
      if (exceptWrap && w === exceptWrap) return;
      dwCloseThumbPanel(w);
    });
  }

  function dwSyncThumbTrigger(select) {
    const wrap = select.closest('.dw-custom-select--thumb');
    if (!wrap) return;
    const trigText = wrap.querySelector('.dw-img-select__trigger-text');
    const trigger = wrap.querySelector('.dw-img-select__trigger');
    const label = select.dataset.optionLabel || '';
    const opt = select.options[select.selectedIndex];
    if (!trigText || !trigger) return;

    if (!opt || !opt.value) {
      const placeholder = select.options[0];
      trigText.textContent = (placeholder && placeholder.textContent) ? placeholder.textContent : label;
    } else {
      trigText.textContent = opt.textContent;
    }

    const al = label + (opt && opt.value ? ': ' + opt.textContent : '');
    trigger.setAttribute('aria-label', al);

    const val = opt && opt.value ? opt.value : '';
    wrap.querySelectorAll('.dw-img-select__option').forEach(btn => {
      btn.setAttribute('aria-selected', btn.dataset.optionValue === val ? 'true' : 'false');
    });
  }

  function dwInitThumbCustomSelects() {
    document.querySelectorAll('.dw-custom-select--thumb').forEach(wrap => {
      const select = wrap.querySelector('select.dw-custom-option-select');
      const trigger = wrap.querySelector('.dw-img-select__trigger');
      const panel = wrap.querySelector('.dw-img-select__panel');
      if (!select || !trigger || !panel) return;

      dwSyncThumbTrigger(select);

      trigger.addEventListener('click', e => {
        e.stopPropagation();
        const willOpen = panel.hidden;
        if (willOpen) dwCloseAllThumbPanels(null);
        panel.hidden = !willOpen;
        wrap.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        // Keyboard-activated click: move focus into listbox; mouse leaves focus on trigger
        if (willOpen && e.detail === 0) {
          const opts = panel.querySelectorAll('.dw-img-select__option');
          let focusIdx = 0;
          if (select.selectedIndex > 0) focusIdx = Math.min(select.selectedIndex - 1, opts.length - 1);
          opts[focusIdx]?.focus();
        }
      });

      panel.querySelectorAll('.dw-img-select__option').forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          const val = btn.dataset.optionValue;
          const match = Array.from(select.options).find(o => o.value === val);
          if (match) {
            select.selectedIndex = match.index;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          dwSyncThumbTrigger(select);
          dwCloseThumbPanel(wrap);
          trigger.focus();
        });
      });

      trigger.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !panel.hidden) {
          e.preventDefault();
          dwCloseThumbPanel(wrap);
          return;
        }
        if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && panel.hidden) {
          e.preventDefault();
          panel.hidden = false;
          wrap.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          dwCloseAllThumbPanels(wrap);
          const opts = [...panel.querySelectorAll('.dw-img-select__option')];
          let idx = e.key === 'ArrowDown' ? 0 : opts.length - 1;
          if (e.key === 'ArrowUp' && select.selectedIndex > 0) {
            idx = Math.min(select.selectedIndex - 1, opts.length - 1);
          }
          if (e.key === 'ArrowDown' && select.selectedIndex > 0) {
            idx = Math.min(select.selectedIndex - 1, opts.length - 1);
          }
          opts[idx]?.focus();
        }
      });

      panel.addEventListener('keydown', e => {
        const opts = [...panel.querySelectorAll('.dw-img-select__option')];
        const i = opts.indexOf(document.activeElement);
        if (e.key === 'Escape') {
          e.preventDefault();
          dwCloseThumbPanel(wrap);
          trigger.focus();
        } else if (e.key === 'ArrowDown') {
          e.preventDefault();
          opts[Math.min(i + 1, opts.length - 1)]?.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          if (i <= 0) {
            dwCloseThumbPanel(wrap);
            trigger.focus();
          } else {
            opts[i - 1]?.focus();
          }
        }
      });

      select.addEventListener('change', () => dwSyncThumbTrigger(select));
    });

    document.addEventListener('click', () => {
      document.querySelectorAll('.dw-custom-select--thumb').forEach(w => dwCloseThumbPanel(w));
    });
  }

  dwInitThumbCustomSelects();

  /* ── CUSTOM METAOBJECT OPTIONS (price_impact dropdowns) ── */
  function dwUpdateCustomOptionsPrice() {
    const priceEl = document.querySelector('#dw-price-row .dw-price-now');
    if (!priceEl) return;

    const retailBase = parseFloat(priceEl.dataset.basePrice || priceEl.dataset.variantPrice || 0);
    if (isNaN(retailBase)) return;

    let totalAddon = 0;
    document.querySelectorAll('.dw-custom-option-select option:checked').forEach(opt => {
      const impact = parseFloat(
        opt.dataset.priceModifier || opt.dataset.priceImpact || 0
      );
      if (!isNaN(impact)) totalAddon += impact;
    });

    const finalCents = Math.round((retailBase + totalAddon) * 100);
    priceEl.textContent = dwFormatMoney(finalCents);
    dwEnsureContractorDisplay(Math.round(retailBase * 100));

    const stickyPrice = document.getElementById('dw-sticky-price');
    if (stickyPrice) stickyPrice.textContent = dwFormatMoney(finalCents);
  }

  document.querySelectorAll('.dw-custom-option-select').forEach(sel => {
    dwSyncCustomInputVisibility(sel);
    sel.addEventListener('change', () => {
      sel.classList.remove('dw-select-error');
      const thumbWrap = sel.closest('.dw-custom-select--thumb');
      if (thumbWrap) thumbWrap.classList.remove('dw-select-error');
      sel.closest('.dw-sel-block')?.classList.remove('dw-option-error');
      dwSyncCustomInputVisibility(sel);
      dwUpdateCustomOptionsPrice();
    });
  });

  document.querySelectorAll('.dw-custom-option-input').forEach(inp => {
    inp.addEventListener('input', () => {
      inp.classList.remove('dw-select-error');
      inp.closest('.dw-sel-block')?.classList.remove('dw-option-error');
      dwSetCustomInputMessage(inp, '');
    });
    inp.addEventListener('blur', () => {
      const block = inp.closest('.dw-sel-block, .custom-option-group');
      const sel = block && block.querySelector('.dw-custom-option-select');
      const opt = sel && sel.options[sel.selectedIndex];
      if (!opt || opt.dataset.allowsCustomInput !== 'true') return;
      if (!String(inp.value || '').trim()) return;
      const check = dwValidateCustomInput(inp, opt);
      if (!check.ok) {
        inp.classList.add('dw-select-error');
        block && block.classList.add('dw-option-error');
        dwSetCustomInputMessage(inp, check.message);
      }
    });
  });

  document.querySelectorAll('.dw-wrap select[required]').forEach(sel => {
    sel.addEventListener('change', () => {
      sel.classList.remove('dw-select-error');
      const thumbWrap = sel.closest('.dw-custom-select--thumb');
      if (thumbWrap) thumbWrap.classList.remove('dw-select-error');
      sel.closest('.dw-sel-block')?.classList.remove('dw-option-error');
    });
  });

  document.addEventListener('dw:variantChanged', () => {
    dwUpdateCustomOptionsPrice();
  });

  if (dwIsContractorCustomer()) {
    dwUpdateCustomOptionsPrice();
  }

  /* ── OPTION GROUP HELP: modal popover (delegated — Theme Editor section reloads) ── */
  function dwCloseOptionHelp(exceptWrap) {
    document.querySelectorAll('.dw-option-help.is-open').forEach(wrap => {
      if (exceptWrap && wrap === exceptWrap) return;
      wrap.classList.remove('is-open');
      const trigger = wrap.querySelector('.dw-option-help__trigger');
      const backdrop = wrap.querySelector('.dw-option-help__backdrop');
      const panel = wrap.querySelector('.dw-option-help__panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (backdrop) backdrop.hidden = true;
      if (panel) panel.hidden = true;
    });
    if (!exceptWrap || !document.querySelector('.dw-option-help.is-open')) {
      document.body.classList.remove('dw-option-help-open');
    }
  }

  function dwOpenOptionHelp(wrap) {
    const trigger = wrap.querySelector('.dw-option-help__trigger');
    const backdrop = wrap.querySelector('.dw-option-help__backdrop');
    const panel = wrap.querySelector('.dw-option-help__panel');
    const closeBtn = wrap.querySelector('.dw-option-help__close');
    if (!trigger || !backdrop || !panel) return;
    wrap.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    backdrop.hidden = false;
    panel.hidden = false;
    document.body.classList.add('dw-option-help-open');
    const focusEl = closeBtn || panel;
    if (focusEl && focusEl.focus) {
      try {
        focusEl.focus({ preventScroll: true });
      } catch (err) {
        focusEl.focus();
      }
    }
  }

  function dwInitOptionGroupHelp() {
    if (document.documentElement.dataset.dwOptionHelpInit) return;
    document.documentElement.dataset.dwOptionHelpInit = '1';

    document.addEventListener('click', e => {
      const closeBtn = e.target.closest('.dw-option-help__close');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const wrap = closeBtn.closest('[data-dw-option-help]');
        const trigger = wrap?.querySelector('.dw-option-help__trigger');
        dwCloseOptionHelp();
        trigger?.focus();
        return;
      }

      if (e.target.closest('.dw-option-help__backdrop')) {
        e.stopPropagation();
        const wrap = e.target.closest('[data-dw-option-help]');
        const trigger = wrap?.querySelector('.dw-option-help__trigger');
        dwCloseOptionHelp();
        trigger?.focus();
        return;
      }

      const trigger = e.target.closest('.dw-option-help__trigger');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      const wrap = trigger.closest('[data-dw-option-help]');
      if (!wrap) return;
      const isOpen = wrap.classList.contains('is-open');
      dwCloseOptionHelp();
      if (!isOpen) dwOpenOptionHelp(wrap);
    });

    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape' || !document.querySelector('.dw-option-help.is-open')) return;
      const openWrap = document.querySelector('.dw-option-help.is-open');
      const trigger = openWrap?.querySelector('.dw-option-help__trigger');
      dwCloseOptionHelp();
      trigger?.focus();
    });
  }

  dwInitOptionGroupHelp();

  /* ── BACK IN STOCK: notify modal (delegated — stock line HTML is replaced on variant change) ── */
  function dwInitNotifyModal() {
    const modal = document.getElementById('dw-notify-modal');
    if (!modal || document.documentElement.dataset.dwNotifyInit) return;
    document.documentElement.dataset.dwNotifyInit = '1';

    document.addEventListener('click', e => {
      const closeEl = e.target.closest('[data-dw-notify-close]');
      if (closeEl) {
        e.preventDefault();
        dwCloseNotifyModal();
        return;
      }

      const notifyLink = e.target.closest('.dw-notify-link');
      if (notifyLink) {
        e.preventDefault();
        dwOpenNotifyModal();
        return;
      }

      const notifyBtn = e.target.closest('#dw-add-btn[data-dw-notify], #dw-sticky-add-btn[data-dw-notify]');
      if (notifyBtn) {
        e.preventDefault();
        dwOpenNotifyModal();
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      const openModal = document.getElementById('dw-notify-modal');
      if (openModal && !openModal.hidden) {
        dwCloseNotifyModal();
      }
    });

    const notifyForm = document.getElementById('dw-pdp-notify-form');
    const notifyPosted =
      !dwNotifyUsesShopifyForms() &&
      !!(notifyForm && notifyForm.querySelector('.form-success'));
    if (notifyPosted) {
      dwOpenNotifyModal();
    }

    if (notifyForm && dwNotifyUsesShopifyForms()) {
      notifyForm.addEventListener('submit', function (e) {
        e.preventDefault();
        const wrap = dwNotifyFormWrap();
        if (wrap) dwNotifySubmitShopifyForm(wrap);
      });

      const wrap = dwNotifyFormWrap();
      if (wrap) {
        const emailInput = wrap.querySelector('[data-dw-notify-input="email"]');
        if (emailInput) {
          emailInput.addEventListener('input', function () {
            dwNotifySetStatus(wrap, '', null);
            const email = String(emailInput.value || '').trim();
            if (email) dwNotifySyncEmailToShadow(wrap, email);
          });
        }

        const prime = function () { dwNotifyPrefill(wrap); };
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(prime, { timeout: 4000 });
        } else {
          window.setTimeout(prime, 500);
        }

        document.addEventListener('pointerenter', function (e) {
          if (e.target.closest('.dw-notify-link, [data-dw-notify="true"]')) prime();
        }, true);
      }
    }
  }

  dwInitNotifyModal();
  dwSyncAddButtonForAvailability(findVariant() || data.currentVariant);

  /* Custom option properties + _doorware_base are now collected
     inside the unified AJAX submit handler above. */

})();
